import type { Button, ComponentProps, ComponentState, Slot, TooltipProps } from '@fluentui/react-components';

export type GroundingMenuSubmenuHeaderSlots = {
  root: NonNullable<Slot<'div'>>;
  backButton?: Slot<typeof Button>;
  backButtonTooltip?: Slot<TooltipProps>;
  primaryText?: Slot<'div'>;
  secondaryText?: Slot<'div'>;
};

/**
 * GroundingMenuSubmenuHeader Props
 */
export type GroundingMenuSubmenuHeaderProps = ComponentProps<Partial<GroundingMenuSubmenuHeaderSlots>> & {};

/**
 * State used in rendering GroundingMenuSubmenuHeader
 */
export type GroundingMenuSubmenuHeaderState = ComponentState<GroundingMenuSubmenuHeaderSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from GroundingMenuSubmenuHeaderProps.
// & Required<Pick<GroundingMenuSubmenuHeaderProps, 'propName'>>
